var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.103,
    height: 16.237,
    viewBox: "0 0 17.103 16.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase_1_",
    "data-name": "briefcase (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18947",
    "data-name": "Path 18947",
    d: "M158.452,1.727a.7.7,0,0,1,.7-.7h3.131a.7.7,0,0,1,.7.7V2.3h1.03V1.727A1.729,1.729,0,0,0,162.28,0h-3.131a1.729,1.729,0,0,0-1.727,1.727V2.3h1.03Zm0,0",
    transform: "translate(-152.164 0)",
    fill: "#adafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18948",
    "data-name": "Path 18948",
    d: "M13.295,259.469v.728a.515.515,0,0,1-1.03,0v-.728H4.838v.728a.515.515,0,1,1-1.03,0v-.728H0v5.905a1.667,1.667,0,0,0,1.665,1.665H15.438a1.667,1.667,0,0,0,1.665-1.665v-5.905Zm0,0",
    transform: "translate(0 -250.802)",
    fill: "#adafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18949",
    "data-name": "Path 18949",
    d: "M3.809,103.984v-.728a.515.515,0,1,1,1.03,0v.728h7.427v-.728a.515.515,0,0,1,1.03,0v.728H17.1v-2.643a1.667,1.667,0,0,0-1.665-1.665H1.666A1.667,1.667,0,0,0,0,101.341v2.643Zm0,0",
    transform: "translate(-0.001 -96.346)",
    fill: "#adafb3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.1f63dc53614979d15eb8dd7a2bbf9c4f.svg";
export { ForwardRef as ReactComponent };